import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

export default function CountdownTimer({ startTime }) {
  const navigate = useNavigate();
  const [remainingMs, setRemainingMs] = useState(
    30 * 60 * 1000 - (Date.now() - startTime)
  );

  useEffect(() => {
    const interval = setInterval(() => {
      const elapsed = Date.now() - startTime;
      const remaining = 30 * 60 * 1000 - elapsed;
      setRemainingMs(remaining);

      if (remaining <= 0) {
        clearInterval(interval);
        navigate(`/payment_temp`);
      }
    }, 1000);

    return () => clearInterval(interval);
  }, [startTime,navigate]);

  if (remainingMs <= 0) {
    return <div className="text-red-600 font-bold">⏰ 已超過 30 分鐘，返回首頁...</div>;
  }

  const minutes = Math.floor(remainingMs / 60000);
  const seconds = Math.floor((remainingMs % 60000) / 1000);

  return (
    <div className="text-green-600 font-semibold">
      ⏳ 還剩 {minutes} 分 {seconds.toString().padStart(2, "0")} 秒
    </div>
  );
}
